import { ObjectTools } from '../../../tools/object-tools';
import { SolTextBox, SolTextBoxCollapsedHeight } from '../../../models/core/sol-text-box';

export class SolTextBoxState {
  private constructor(
    public readonly box: SolTextBox,
    public readonly translatedText: string,
    public readonly expanded: boolean,
    public readonly overflow: boolean,
    public readonly visibleText: string,
    public readonly collapsedHeight: SolTextBoxCollapsedHeight,
    public readonly clamped: boolean,
    public readonly faded: boolean,
    public readonly showMoreVisible: boolean,
    public readonly showLessVisible: boolean,
    public readonly hostClass: string,
  ) {}

  public static of(): SolTextBoxState {
    return new SolTextBoxState(
      SolTextBox.empty(),
      '',
      false,
      false,
      '',
      '256',
      false,
      false,
      false,
      false,
      '',
    ).recalculate();
  }

  public withBox(box: SolTextBox): SolTextBoxState {
    return this.copy({ box, overflow: false }).recalculate();
  }

  public withTranslatedText(translatedText: string): SolTextBoxState {
    return this.copy({ translatedText }).recalculate();
  }

  public withExpanded(expanded: boolean): SolTextBoxState {
    if (this.expanded === expanded) {
      return this;
    }
    return this.copy({ expanded }).recalculate();
  }

  public withOverflow(overflow: boolean): SolTextBoxState {
    if (this.overflow === overflow) {
      return this;
    }
    return this.copy({ overflow }).recalculate();
  }

  private recalculate(): SolTextBoxState {
    const box = this.box;
    const collapsedHeight = box.collapsedHeight;
    const collapsible = collapsedHeight !== 'none';
    const clamped = collapsible && !this.expanded;
    const faded = clamped && this.overflow;
    const showMoreVisible = clamped && this.overflow;
    const showLessVisible = collapsible && this.expanded && this.overflow;
    const visibleText = this.translatedText;
    const hostClass = [
      'sol-text-box',
      collapsible ? `sol-text-box-height-${collapsedHeight}` : '',
      clamped ? 'sol-text-box-clamped' : '',
      faded ? 'sol-text-box-faded' : '',
      box.centered ? 'sol-text-box-centered' : '',
    ]
      .filter(token => token !== '')
      .join(' ');
    return this.copy({ collapsedHeight, clamped, faded, showMoreVisible, showLessVisible, visibleText, hostClass });
  }

  private copy(props: Partial<SolTextBoxState>): SolTextBoxState {
    return ObjectTools.copy<SolTextBoxState>(this, props);
  }
}
